module.exports = __webpack_public_path__ + "../resources/images/sad-3b27a5f0b742a2aa9a6f5e0f911f6ead.svg";